<template>
  <div style="padding: 10px">
    <!-- 搜索区域 -->
    <div style="margin: 10px 0">
      <el-select v-model="search.isDelete" placeholder="公告状态" style="width: 20%" clearable>
        <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="search.content" placeholder="输入公告内容" @keyup.enter.native="load" style="width: 20%"
                clearable></el-input>

      <el-button type="primary" style="margin-left: 5px" @click="load">查询</el-button>
      <el-button style="margin-left: 5px" @click="resetData">重置</el-button>
      <el-button type="success" style="margin-left: 5px" @click="handleAdd">新增</el-button>
    </div>

    <!-- 表格区域 -->
    <el-table
        v-loading="loading"
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="content"
          label="公告内容"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="createTime"
          label="公告日期"
          width="120"
          show-overflow-tooltip>
      </el-table-column>
      <el-table-column
          prop="sort"
          label="排序"
          width="80"
          sortable>
      </el-table-column>
      <el-table-column
          prop="isDelete"
          label="启用标识"
          width="100"
          :formatter="formatStatus">
      </el-table-column>
      <el-table-column label="操作" width="100px" v-if="this.userId === 1">
        <template #default="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>

    <!-- 新增/编辑表单 -->
    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="40%">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="公告内容" prop="content">
          <el-input
              v-model="form.content"
              type="textarea"
              :rows="4"
              placeholder="请输入公告内容"
              maxlength="500"
              show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="公告日期" prop="createTime">
          <el-date-picker
              v-model="form.createTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="启用标识" prop="isDelete">
          <el-select v-model="form.isDelete" placeholder="请选择状态" style="width: 100%">
            <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
              v-model="form.sort"
              :min="1"
              :max="999"
              controls-position="right"
              style="width: 100%"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="save">确 定</el-button>
          </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'NoticeManagement',
  components: {},
  data() {
    return {
      dialogVisible: false,
      dialogTitle: '新增公告',
      form: {
        id: '',
        content: '',
        createTime: '',
        isDelete: 0,
        sort: 1
      },
      formRef: null,
      rules: {
        content: [
          { required: true, message: '请输入公告内容', trigger: 'blur' },
          { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: '请选择公告日期', trigger: 'change' }
        ],
        sort: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ]
      },
      userId: '',
      loading: true,
      search: {
        isDelete: 0,
        content:''
      },
      query: {},
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],

      // 状态选项
      statusOptions: [
        { label: '启用', value: 0 },
        { label: '过期', value: 1 },
        { label: '备用', value: 2 }
      ]
    }
  },
  created() {
    // 初始化用户信息
    let userStr = sessionStorage.getItem("user") || "{}"
    let user = JSON.parse(userStr)
    this.userId = user.id;

    // 加载数据
    this.load();
  },
  methods: {
    // 格式化状态显示
    formatStatus(row, column, cellValue) {
      const statusMap = {
        0: '启用',
        1: '过期',
        2: '备用'
      };
      return statusMap[cellValue] || '未知';
    },

    // 重置搜索条件
    resetData() {
      this.search = {
        isDelete: '',
        content:''
      }
      this.currentPage = 1;
      this.load();
    },

    // 新增按钮
    handleAdd() {
      this.dialogTitle = '新增公告';
      this.form = {
        id: '',
        content: '',
        createTime: this.getCurrentDate(),
        isDelete: 0,
        sort: 1
      };
      this.dialogVisible = true;
    },

    // 编辑按钮
    handleEdit(row) {
      this.dialogTitle = '编辑公告';
      this.form = {
        id: row.id,
        content: row.content,
        createTime: row.createTime,
        isDelete: row.isDelete,
        sort: row.sort
      };
      this.dialogVisible = true;
    },

    // 获取当前日期
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 保存（新增/编辑）
    save() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.loading = true;

          // 深拷贝表单数据
          const formData = JSON.parse(JSON.stringify(this.form));

          // 根据是否有id决定调用哪个接口
          const url = formData.id ? "/miniProgramNotice/update" : "/miniProgramNotice/save";

          request.post(url, formData).then(res => {
            this.loading = false;
            if (res.code === '0') {
              this.$message({
                type: "success",
                message: res.msg || "操作成功"
              });
              this.dialogVisible = false;
              this.load(); // 刷新数据
            } else {
              this.$message({
                type: "error",
                message: res.msg || "操作失败"
              });
            }
          }).catch(error => {
            this.loading = false;
            this.$message.error("网络错误，操作失败");
          });
        } else {
          return false;
        }
      });
    },

    // 加载数据
    load() {
      this.loading = true;

      // 构建查询参数
      const params = {
        current: this.currentPage,
        size: this.pageSize
      };

      // 添加搜索条件
      if (this.search.isDelete !== '' && this.search.isDelete !== undefined && this.search.isDelete !== null) {
        params.isDelete = this.search.isDelete;
      }
      if (this.search.content !== '' && this.search.content !== undefined && this.search.content !== null) {
        params.content = this.search.content;
      }

      request.get("/miniProgramNotice/listPage", {
        params: params
      }).then(res => {
        this.loading = false;

        if (res.code === '0') {
          // 处理返回的数据结构
          let data = res.data;

          // 如果返回的是数组
          if (Array.isArray(data)) {
            this.tableData = data;
            this.total = data.length;
          }
          // 如果返回的是分页结构
          else if (data && data.records) {
            this.tableData = data.records || [];
            this.total = data.total || 0;
          }
          // 如果是对象但包含list
          else if (data && data.list) {
            this.tableData = data.list || [];
            this.total = data.total || 0;
          }
          else {
            this.tableData = [];
            this.total = 0;
          }

          // 按sort字段排序
          this.tableData.sort((a, b) => a.sort - b.sort);
        } else {
          this.$message.error(res.msg || '加载失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch(error => {
        this.loading = false;
        this.$message.error('网络错误，加载失败');
        this.tableData = [];
        this.total = 0;
      });
    },

    // 改变每页显示数量
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },

    // 改变当前页码
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    },
  }
}
</script>

<style scoped>
/* 可选的样式调整 */
.el-select {
  margin-right: 10px;
}

.el-table {
  margin-top: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: center;
}
</style>
